import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import classnames from 'classnames';
import { ClassNames } from '@emotion/core';

var MultiValue = function MultiValue(props) {
  var _option$style, _option$className;

  var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      option = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;

  var _key = option.key ? option.key.toString() : '';

  var _style = ((_option$style = option.style) === null || _option$style === void 0 ? void 0 : _option$style.value) || option.style;

  var _innerProps = _objectSpread(_objectSpread({}, innerProps), {}, {
    style: _style
  });

  var _className = ((_option$className = option.className) === null || _option$className === void 0 ? void 0 : _option$className.value) || option.className;

  return React.createElement(ClassNames, null, function (_ref) {
    var css = _ref.css,
        emotionCx = _ref.cx;
    return React.createElement(Container, {
      data: option,
      innerProps: _objectSpread(_objectSpread({}, _innerProps), {}, {
        className: emotionCx(css(getStyles('multiValue', props)), cx(_defineProperty({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, "multi-value--".concat(_key), !!_key), classnames(_className, className)))
      }),
      selectProps: selectProps
    }, React.createElement(Label, {
      data: option,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }))
      },
      selectProps: selectProps
    }, children), React.createElement(Remove, {
      data: option,
      innerProps: _objectSpread({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }))
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

MultiValue.defaultProps = {
  cropWithEllipsis: true
};
export default MultiValue;